import { t } from "@lingui/macro"
import React from "react"
import { match } from "ts-pattern"
import { VenetianSocietyStatus } from "../helpers"
import { ValidatedCardPromoBadges } from "../../../_common/promo-badges"
import { CardPromoBadgesContent } from "../../../../_common/sanity/sanity-types"
import FarePromoBadge from "./FarePromoBadge"
import styles from "./FareFooterPromoBadges.module.scss"

type Props = {
    promoBadges?: readonly ValidatedCardPromoBadges<CardPromoBadgesContent>[]
    venetianSocietyStatus?: VenetianSocietyStatus
}

export const showFareFooterPromoBadges = (
    promoBadges?: Props["promoBadges"],
    venetianSocietyStatus?: Props["venetianSocietyStatus"],
) => {
    const showVSBadge = venetianSocietyStatus && venetianSocietyStatus !== "non-eligible"
    return !((promoBadges || []).length === 0 && !showVSBadge)
}

const FareFooterPromoBadges: React.FC<Props> = ({ promoBadges, venetianSocietyStatus }) => {
    if (!showFareFooterPromoBadges(promoBadges, venetianSocietyStatus)) {
        return null
    }

    const vsPromoTitle = match(venetianSocietyStatus)
        .with("applied", () => t`Venetian society saving applied`)
        .with("eligible", () => t`Venetian society saving eligible`)
        .with("non-eligible", undefined, () => undefined)
        .exhaustive()

    return (
        <div className={styles.container}>
            {promoBadges?.map((promo) => {
                return <FarePromoBadge key={promo.code} title={promo.content.title} iconUrl={promo.content.iconUrl} />
            })}

            {venetianSocietyStatus != "non-eligible" && (
                <FarePromoBadge title={vsPromoTitle} icon="venetian-society-saving" />
            )}
        </div>
    )
}

export default FareFooterPromoBadges
